export const errorMessageText = {
  content: 'This Name already exist',
  pointing: 'below',
};
export const errorEmptyText = {
  content: 'Please Enter a Name',
  pointing: 'below',
};
export const selectionEmptyErrorMsg = {
  content: 'Please select an option to clone',
  pointing: 'below',
};
export const errorDot = {
  content: 'Please avoid dot',
  pointing: 'below',
};
export const errortilde = {
  content: 'Please avoid tilde',
  pointing: 'below',
};

export const errorEmptyTextNoPointing = {
  content: '',
  pointing: 'none',
};
export const cardcolor = {
  backgroundColor: 'lightgray',
  color: 'black',
};
export const cardcolor2 = {
  backgroundColor: 'rgb(245,245,245)',
  color: 'rgb(245,245,245)',
};
export const cardcolor3 = {
  backgroundColor: '#e6e6e6',
  // color: "rgb(245,245,245)",
};
export const departmenterrorMessageText = {
  content: 'This Department Name already exist',
};
export const departmentCodeerrorMessageText = {
  content: 'This Department Code already exist',
};
export const departmentEmailerrorMessageText = {
  content: 'This Department Email already exist',
};
export const departmentPhoneerrorMessageText = {
  content: 'This Phone number already exist',
};
export const vaulterrorMessageText = {
  content: 'This Vault Name already exist',
};
